/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PharmacyAccess from './pharmacy-access';
import PharmacyAccessDetail from './pharmacy-access-detail';
import PharmacyAccessUpdate from './pharmacy-access-update';
import PharmacyAccessDeleteDialog from './pharmacy-access-delete-dialog';

const PharmacyAccessRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PharmacyAccess />} />
    <Route path="new" element={<PharmacyAccessUpdate />} />
    <Route path=":id">
      <Route index element={<PharmacyAccessDetail />} />
      <Route path="edit" element={<PharmacyAccessUpdate />} />
      <Route path="delete" element={<PharmacyAccessDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PharmacyAccessRoutes;
